import { render, staticRenderFns } from "./RecibirEnvio.vue?vue&type=template&id=578d2d06"
import script from "./RecibirEnvio.vue?vue&type=script&lang=js"
export * from "./RecibirEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports